import { render, staticRenderFns } from "./ListDomains.vue?vue&type=template&id=4b61d5ac&"
import script from "./ListDomains.vue?vue&type=script&lang=ts&"
export * from "./ListDomains.vue?vue&type=script&lang=ts&"
import style0 from "./ListDomains.vue?vue&type=style&index=0&id=4b61d5ac&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports